/**
 * vue-smb-pmg-roi
 * @version 1.0.0
 * @author Erik Ondrus <erik.ondrus@avast.com>
 * @requires chartjs-2.7.1.min.js	(j/v2/smb/vendor/chartjs-2.7.1.min.js)
 * @requires vue-chartjs-3.5.1.min.js	(j/v2/smb/vendor/vue-chartjs-3.5.1.min.js)
 * @requires accounting.min.js	(j/v2/smb/vendor/accounting.min.js)
 * @requires vue-numeric.min.js	(j/v2/smb/vendor/vue-numeric.min.js)
 */

(function() {
	'use strict';

	Vue.use(VueNumeric.default);
	Vue.config.devtools = true;

	var appHook = document.getElementById('vue-tco-calculator');

	if (appHook.length === 0) {
		return false;
	}

	Vue.component('bar-chart', {
		extends: VueChartJs.Bar,
		mixins: [VueChartJs.mixins.reactiveProp],
		props: ['options'],
		mounted: function() {
			this.renderChart(this.chartData, this.options);
		}
	});

	Vue.component('avast-product-option', {
		delimiters: ['{%', '%}'],
		props: ['value', 'products_to_display', 'price', 'input_id', 'label_product', 'label_users', 'label_cost', 'price_format'],
		template: '#avast-product-option',
		computed: {
			isQuantityError: function() {
				return getIsQuantityError(this.value.numberOfUsers, this.products_to_display.minQuantity, this.products_to_display.maxQuantity);
			}
		},
		methods: {
			update: function(key, targetValue) {
				this.$emit('input', _objectSpread(_objectSpread({}, this.value), {}, _defineProperty({}, key, targetValue)));
			},
			htmlDecode: function(input) {
				var doc = new DOMParser().parseFromString(input, 'text/html');
				return doc.documentElement.textContent;
			}
		}
	});

	var app = new Vue({
		el: appHook,
		delimiters: ['{%', '%}'],

		beforeCreate: function() {
			this.PRODUCTS_TO_DISPLAY = JSON.parse(appHook.dataset.productsToDisplay || null);
			this.PRICING = JSON.parse(appHook.dataset.pricing || null);
			this.PRICING_COMPETITOR_AV_SPA = JSON.parse(appHook.dataset.pricingCompetitor || null);
			this.PRICING_COMPETITOR_SIG = JSON.parse(appHook.dataset.pricingCompetitorSig || null);
			this.LOCAL_PRICE_FORMAT = JSON.parse(appHook.dataset.localPriceFormat || null);
			this.REQUESTED_CURRENCY_CODE = appHook.dataset.currencyCode || 'USD';

			this.UTM_MAPS = JSON.parse(appHook.dataset.utmMap || null);
			this.UTM_MAP_SINGLE = this.UTM_MAPS.SINGLE;
			this.UTM_MAP_MULTIPLE = this.UTM_MAPS.MULTIPLE;

			this.CONECTIVITY_OPTIONS = [50, 100, 150, 200, 250, 300, 350, 400, 450, 500, 550, 600, 650, 700, 750, 800, 850, 900, 950, 1000, 1050, 1100, 1150, 1200, 1250, 1300, 1350, 1400, 1450, 1500, 1550, 1600, 1650, 1700, 1750, 1800, 1850, 1900, 1950, 2000];
		},

		data: {
			numberOfEmployees: 25,
			numberOfLocations: 1,
			numberOfWorkstations: 25,
			numberOfVpnUsers: 50,
			speedConectivity: 50,

			productSig: {
				productIdSelected: 32,
				numberOfUsers: 25
			},
			productAv: {
				productIdSelected: 3,
				numberOfUsers: 25
			},
			productSpa: {
				productIdSelected: 63,
				numberOfUsers: 50
			}
		},

		computed: {

			/*
			 * @returns {string} "UTM" key ("UTM1") used to calculate SIG competitor's price
			 */
			utmKeyForCompSig: function() {
				return this.numberOfLocations < 2 ? this.getUtmKey(this.UTM_MAP_SINGLE, this.speedConectivity) : this.getUtmKey(this.UTM_MAP_MULTIPLE, this.speedConectivity);
			},

			/*
			 # Filtered competitor products ↓↓↓
			 * @returns {array} array of objects - filtered products
			 */

			productsCompAv1y: function() {
				return this.getFilteredProdcutsById(this.PRICING_COMPETITOR_AV_SPA, 'av-1y');
			},

			productsCompAv3y: function() {
				return this.getFilteredProdcutsById(this.PRICING_COMPETITOR_AV_SPA, 'av-3y');
			},

			productsCompSpa1y: function() {
				return this.getFilteredProdcutsById(this.PRICING_COMPETITOR_AV_SPA, 'spa-1y');
			},

			productsCompSpa3y: function() {
				return this.getFilteredProdcutsById(this.PRICING_COMPETITOR_AV_SPA, 'spa-3y');
			},

			/*
			 # Competitor pricing ↓↓↓
			 * @returns {number} Competitor Price
			 */

			priceCompAv1y: function() {
				var unitPrice = this.getUnitPrice(this.productsCompAv1y, this.numberOfWorkstations);
				var price = unitPrice * this.numberOfWorkstations;
				return price >= 0 ? price : 0;
			},

			priceCompAv3y: function() {
				var unitPrice = this.getUnitPrice(this.productsCompAv3y, this.numberOfWorkstations);
				var price = unitPrice * this.numberOfWorkstations;
				return price >= 0 ? price : 0;
			},

			priceCompSpa1y: function() {
				var unitPrice = this.getUnitPrice(this.productsCompSpa1y, this.numberOfVpnUsers);
				var price = unitPrice + 1995;
				return price >= 0 ? price : 0;
			},

			priceCompSpa3y: function() {
				var unitPrice = this.getUnitPrice(this.productsCompSpa3y, this.numberOfVpnUsers);
				var price = unitPrice + 1995;
				return price >= 0 ? price : 0;
			},

			/*
			 * @returns {number} Competitor Price based on UTM map - SIG - 1Y
			 */
			priceCompSig1y: function() {
				return this.getPriceCompSig(this.utmKeyForCompSig, '1Y');
			},

			/*
			 * @returns {number} Competitor Price based on UTM map - SIG - 3Y
			 */
			priceCompSig3y: function() {
				return this.getPriceCompSig(this.utmKeyForCompSig, '3Y');
			},

			/*
			 # Filtered competitor products ↓↓↓
			 * @returns {array} array of objects - filtered products
			 */

			productsAvastAv: function() {
				return this.getFilteredProdcutsById(this.PRICING, this.productAv.productIdSelected);
			},

			productsAvastSpa: function() {
				return this.getFilteredProdcutsById(this.PRICING, this.productSpa.productIdSelected);
			},

			productsAvastSig: function() {
				return this.getFilteredProdcutsById(this.PRICING, this.productSig.productIdSelected);
			},

			/*
			 # Avast pricing ↓↓↓
			 * @returns {number} final price for avast product
			 */

			priceAvastAv: function() {
				if (this.checkQuantityErrorForAvast(this.productAv.numberOfUsers, 'av')) {
					return 0;
				}

				var unitPrice = this.getUnitPrice(this.productsAvastAv, this.productAv.numberOfUsers);
				return unitPrice * this.productAv.numberOfUsers;
			},

			priceAvastSpa: function() {
				if (this.checkQuantityErrorForAvast(this.productSpa.numberOfUsers, 'spa')) {
					return 0;
				}

				var unitPrice = this.getUnitPrice(this.productsAvastSpa, this.productSpa.numberOfUsers);
				return unitPrice * this.productSpa.numberOfUsers;
			},

			priceAvastSig: function() {
				if (this.checkQuantityErrorForAvast(this.productSig.numberOfUsers, 'sig')) {
					return 0;
				}

				var unitPrice = this.getUnitPrice(this.productsAvastSig, this.productSig.numberOfUsers);
				return unitPrice * this.productSig.numberOfUsers;
			},

			/*
			 # Results ↓↓↓
			 * @returns {number} costs
			 */

			resultUtmCost1y: function() {
				return this.priceCompAv1y + this.priceCompSpa1y + this.priceCompSig1y;
			},

			resultUtmCost3y: function() {
				return this.priceCompAv3y + this.priceCompSpa3y + this.priceCompSig3y;
			},

			resultAvastCost1y: function() {
				return this.priceAvastAv + this.priceAvastSpa + this.priceAvastSig;
			}
		},

		watch: {
			numberOfEmployees: function(val) {
				this.productSig.numberOfUsers = val;
				this.productAv.numberOfUsers = val;
			},
			numberOfVpnUsers: function(val) {
				this.productSpa.numberOfUsers = val;
			}
		},

		methods: {

			/*
			 * @param {array} utm map (UTM_MAP_SINGLE/UTM_MAP_MULTIPLE)
			 * @param {number} value - speedConectivity
			 * @returns {string} UTM key
			 */
			getUtmKey: function(utmMap, value) {
				var itemInRange = utmMap.find(function(item) {
					return value >= item.QTY_START && value <= item.QTY_END;
				});

				return itemInRange ? itemInRange.UTM : utmMap[utmMap.length - 1].UTM; // If not found, take last value - it is ordered
			},

			/*
			 * @param {array} Products
			 * @param {number} quantity - number of devices
			 * @returns {number} Price for one device
			 */
			getUnitPrice: function(products, quantity) {
				if (quantity < 1) {
					return 0;
				}

				var product = products.find(function(product) {
					return quantity >= product.QTY_START && quantity <= product.QTY_END;
				});

				if (!product) {
					return 0;
				}

				return product.PRICE;
			},

			/*
			 * @param {array} Products
			 * @param {string} productId
			 * @returns {array} Filtered products by ID and currency code
			 */
			getFilteredProdcutsById: function(products, productId) {
				var currencyCode = this.REQUESTED_CURRENCY_CODE;
				return products.filter(function(product) {
					return String(product.PRODUCT_ID).toLowerCase() === String(productId).toLowerCase() && String(product.CURRENCY_CODE).toLowerCase() === String(currencyCode).toLowerCase();
				});
			},

			/*
			 * @param {string} utmKey ("UTM1")
			 * @param {string} periodKey ("1Y")
			 * @returns {number} Price for competitor SIG
			 */
			getPriceCompSig: function(utmKey, periodKey) {
				if (this.PRICING_COMPETITOR_SIG[utmKey]) {
					return (this.PRICING_COMPETITOR_SIG[utmKey].HW + this.PRICING_COMPETITOR_SIG[utmKey][periodKey] + this.PRICING_COMPETITOR_SIG[utmKey].HA) * this.numberOfLocations;
				}
				console.error(utmKey + 'does not exist');
				return null;
			},

			/*
			 * @param {number} quantity - number of devices
			 * @param {string} productKey - ('sig', 'av', 'spa')
			 * @returns {booelan} isQuantityError
			 */
			checkQuantityErrorForAvast: function(quantity, productKey) {
				return getIsQuantityError(quantity, this.PRODUCTS_TO_DISPLAY[productKey].minQuantity, this.PRODUCTS_TO_DISPLAY[productKey].maxQuantity);
			},

			/*
			 * @param {string} input - Value to decode (&pound;)
			 * @returns {string} Decoded value (£)
			 */
			htmlDecode: function(input) {
				var doc = new DOMParser().parseFromString(input, 'text/html');
				return doc.documentElement.textContent;
			}
		}
	});

	/*
	 * @param {number} quantity - number of devices
	 * @param {number} minQuantity - min number of devices
	 * @param {number} maxQuantity - max number of devices
	 * @returns {boolean} if the quantity is out of possible range
	 */
	function getIsQuantityError(quantity, minQuantity, maxQuantity) {
		if (Number(quantity) === 0) {
			return false;
		}
		return Number(quantity) < Number(minQuantity) || Number(quantity) > Number(maxQuantity);
	}

	/*
	 # ES6 transpiled ↓↓↓
	 */
	function ownKeys(object, enumerableOnly) {
		var keys = Object.keys(object);
		if (Object.getOwnPropertySymbols) {
			var symbols = Object.getOwnPropertySymbols(object);
			if (enumerableOnly) {
				symbols = symbols.filter(function(sym) {
					return Object.getOwnPropertyDescriptor(object, sym).enumerable;
				});
			}
			keys.push.apply(keys, symbols);
		}
		return keys;
	}

	function _objectSpread(target) {
		for (var i = 1; i < arguments.length; i++) {
			var source = arguments[i] != null ? arguments[i] : {};
			if (i % 2) {
				ownKeys(Object(source), true).forEach(function(key) {
					_defineProperty(target, key, source[key]);
				});
			} else if (Object.getOwnPropertyDescriptors) {
				Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
			} else {
				ownKeys(Object(source)).forEach(function(key) {
					Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
				});
			}
		}
		return target;
	}

	function _defineProperty(obj, key, value) {
		if (key in obj) {
			Object.defineProperty(obj, key, {
				value: value,
				enumerable: true,
				configurable: true,
				writable: true
			});
		} else {
			obj[key] = value;
		}
		return obj;
	}
})();
